<template>
  <div class="collection-bill-page">
    <div class="tabs">
      <div :class="['tab', { active: activeTab === 1 }]" @click="activeTab = 1">收款单列表</div>
      <div :class="['tab', { active: activeTab === 2 }]" @click="activeTab = 2">交易流水</div>
    </div>
    <template v-if="activeTab === 1">
      <div class="search">
        <el-form inline class="inline-form" :model="searchForm" label-width="85px" label-position="right">
          <el-form-item label="创建时间" label-width="100px">
            <el-date-picker
              v-model="rangeTime"
              size="small"
              clearable
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label="创建方式" label-width="100px">
            <el-select v-model="searchForm.createType" size="small" clearable placeholder="请选择创建方式">
              <el-option :value="0" label="手动创建"/>
              <el-option :value="1" label="导入文件"/>
            </el-select>
          </el-form-item>
          <el-form-item label="收款单编号" label-width="100px">
            <el-input v-model="searchForm.receiptOrderNo" size="small" clearable placeholder="请输入收款单编号"/>
          </el-form-item>
          <el-form-item label="收款单名称" label-width="100px">
            <el-input v-model="searchForm.receiptOrderName" size="small" clearable placeholder="请输入收款单名称"/>
          </el-form-item>
          <el-form-item label="收款单类型" label-width="100px">
            <el-select v-model="searchForm.type" size="small" clearable placeholder="请选择收款单类型">
              <el-option
                v-for="([value, label], index) in Object.entries(typeOptions)"
                :key="index"
                :value="value"
                :label="label"/>
            </el-select>
          </el-form-item>
          <el-form-item label="所属门店" label-width="100px" v-if="loginInfo.shopType === 1">
            <CommonSelect
              placeholder="请选择所属门店"
              v-model="searchForm.shopName"
              :options="shopNameOptions"
              :needPaging="true"
              :pageLoading="shopPageInfo.loading"
              :clearable="true"
              @change="handleShopNameChange"
              @loadmore="queryShopMerchantList"
            />
          </el-form-item>
          <el-form-item label="收款单状态" label-width="100px">
            <el-select v-model="searchForm.status" size="small" clearable placeholder="请选择收款单状态">
              <el-option
                v-for="([value, label], index) in Object.entries(statusOptions)"
                :key="index"
                :value="value"
                :label="label"/>
            </el-select>
          </el-form-item>
          <el-form-item label="关联收银点" label-width="100px">
            <el-select v-model="searchForm.cashierAreaNo" size="small" clearable filterable placeholder="请选择关联收银点">
              <el-option
                v-for="item in cashierPointList"
                :key="item.cashierAreaNo"
                :label="item.cashierAreaName"
                :value="item.cashierAreaNo"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleSearch" class="btn-base searchBtn bs-btn">
              查询
            </el-button>
            <el-button size="small" @click="exportDetail" class="btn-base searchBtn bs-btn">导出收款明细</el-button>
            <el-button type="primary" size="small" @click="handleCreate" class="btn-base searchBtn bs-btn">
              创建收款单
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="center-info">
        <span v-for="(item, index) in Object.entries(billInfo)" :key="index">
          {{ billInfoToChinese(item[0]) }}: {{ item[1] }}
        </span>
      </div>
      <div class="table-list">
        <div class="table-data">
          <el-table :data="table.tableData" style="width: 100%;" border v-loading="table.loadingTable">
            <el-table-column prop="createTime" label="创建时间" align="center" width="200"/>
            <el-table-column prop="createTypeDesc" label="创建方式" align="center" width="150"/>
            <el-table-column prop="cashierAreaName" label="关联收银点" align="center" width="150"/>
            <el-table-column prop="receiptOrderNo" label="收款单编号" align="center" width="150"/>
            <el-table-column prop="receiptName" label="收款单名称" align="center" min-width="200"/>
            <el-table-column prop="type" label="收款单类型" align="center" width="180">
              <template slot-scope="{ row }">{{ typeOptions[row.type] || '' }}</template>
            </el-table-column>
            <el-table-column prop="status" label="收款单状态" align="center" width="100">
              <template slot-scope="{ row }">{{ statusOptions[row.status] || '' }}</template>
            </el-table-column>
            <el-table-column prop="totalAmount" label="累计营业收入（元）" align="center" width="150">
              <template slot-scope="{ row }">{{ sToFixed(row.totalAmount) }}</template>
            </el-table-column>
            <el-table-column prop="incomeAmount" label="累计收款金额（元）" align="center" width="150">
              <template slot-scope="{ row }">{{ sToFixed(row.incomeAmount) }}</template>
            </el-table-column>
            <el-table-column prop="incomeCount" label="累计收款笔数（笔）" align="center" width="150"/>
            <el-table-column prop="refundAmount" label="累计退款金额（元）" align="center" width="150">
              <template slot-scope="{ row }">{{ sToFixed(row.refundAmount) }}</template>
            </el-table-column>
            <el-table-column prop="refundCount" label="累计退款笔数（笔）" align="center" width="150"/>
            <el-table-column label="操作" align="center" fixed="right" width="200">
              <template slot-scope="{ row }">
                <el-button class="t-btn" type="text" size="small" @click="handleViewTableDetail(row)">
                  查看收款单详情
                </el-button>
                <el-button class="t-btn" type="text" size="small" @click="goToDetail(row)">收款详情</el-button>
                <el-button class="t-btn" type="text" size="small" @click="showQrCode(row)" v-if="row.status === 1">收款码</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24" class="paginationBox">
            <el-pagination
              v-if="table.totalCount > 0"
              class="pagination"
              :page-size="table.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="table.totalCount"
              :current-page="table.pageNo"
              @current-change="handleCurrentPageChange"
            />
          </el-col>
        </div>
      </div>
      <el-dialog title="收款单详情" :visible.sync="dialog.dialogVisible" width="30%" :before-close="handleDialogClose">
        <el-form
          class="inline-form"
          :model="dialog.form"
          label-width="85px"
          label-position="right"
          size="small"
          v-loading="dialog.loadingDialog">
          <el-form-item label="收款单名称：" label-width="170px">{{ dialog.form.receiptName }}</el-form-item>
          <el-form-item label="收款单编号：" label-width="170px">{{ dialog.form.receiptOrderNo }}</el-form-item>
          <el-form-item label="收款单状态：" label-width="170px">
            {{ statusOptions[dialog.form.status] || '' }}
          </el-form-item>
          <el-form-item label="收款单创建时间：" label-width="170px">{{ dialog.form.createTime }}</el-form-item>
          <el-form-item label="收款单有效期：" label-width="170px">
            {{ dialog.form.validType === 0 ? "长期有效" : `${dialog.form.validDays}天` }}
          </el-form-item>
          <el-form-item label="收款单类型：" label-width="170px">{{ dialog.form.typeStr }}</el-form-item>
          <el-form-item label="收款单笔数上限（笔）：" label-width="170px">{{ dialog.form.receiptNumberUpperLimit }}</el-form-item>
          <el-form-item label="乐刷商户号：" label-width="170px">{{ dialog.form.merchantId }}</el-form-item>
          <el-form-item label="门店编号：" label-width="170px">{{ dialog.form.shopId }}</el-form-item>
          <el-form-item label="门店名称：" label-width="170px">{{ dialog.form.merchantName }}</el-form-item>
          <el-form-item label="关联收银点：" label-width="170px">{{ dialog.form.cashierAreaName }}</el-form-item>
          <el-form-item label="是否设置收款密码：" label-width="170px">{{ dialog.form.receivePwdStr }}</el-form-item>
          <el-form-item label="收款密码：" label-width="170px">{{ dialog.form.receivePwd }}</el-form-item>
          <el-form-item label="收款备注：" label-width="170px">{{ dialog.form.title }}</el-form-item>
        </el-form>
        <div slot="footer" style="text-align: center;">
          <el-button class="bs-btn" type="primary" @click="handleConfirmDialog" :loading="dialog.loadingConfirmBtn" v-if="[1, 2].includes(dialog.form.status)">
            {{ dialog.form.status === 2 ? '重启收款' : '结束收款' }}
          </el-button>
        </div>
      </el-dialog>
    </template>
    <template v-else>
      <Flow/>
    </template>
    <el-dialog
      :visible.sync="showCreateDialog"
      width="470px"
      class="dialog-wrap"
      title="请选择创建模板"
      @close="showCreateDialog = false"
      :close-on-click-modal="false">
      <div>
        <ul class="template-list">
          <li
            v-for="(item, index) in templateList"
            class="item flex flex-center"
            :class="{ active: currCreateTemplateIndex === index }"
            :key="index"
            @click="currCreateTemplateIndex = index">
            <img :src="item.imgUrl" class="icon"/>
            <div>
              <p class="name">{{ item.name }}</p>
              <p class="desc">{{ item.desc }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div slot="footer">
        <el-button class="bs-btn2" type="primary" @click="showCreateDialog = false">取消</el-button>
        <el-button class="bs-btn" type="primary" @click="handleConfirmCreate">
          确定
        </el-button>
      </div>
    </el-dialog>
    <qrcode-dialog
      :show-dialog="showQrDialog"
      :receiptOrderNo="qrDialogInfo.receiptOrderNo"
      :receiptName="qrDialogInfo.receiptName"
      :merchantName="qrDialogInfo.merchantName"
      @close="handleCloseQrDialog"/>
  </div>
</template>

<script>
import {
  closeOrOpenReceipt,
  getListShopMerchant,
  queryDebitNoteDetail,
  queryDebitNoteList,
  queryListAllRecordSummary,
} from "@/api/collection-bill";
import { queryCashierList } from "@/api/flow";
import { downLoadFileByForm, sToFixed } from "@/utils/index";
import { host } from "@/global-config";
import CommonSelect from "@/components/CommonSelect.vue";
import Flow from "./flow.vue";
import qrcodeDialog from "./qrcodeDialog.vue";

export default {
  name: "collection-bill-index",
  components: {
    CommonSelect,
    Flow,
    qrcodeDialog,
  },
  data() {
    return {
      activeTab: 1,
      shopPageInfo: {
        loading: false,
        pageNo: 1,
        finished: false,
        pageSize: 30,
      },
      rangeTime: null,
      searchForm: {
        createType: "",
        receiptOrderNo: "",
        receiptOrderName: "",
        type: "",
        shopName: "",
        status: "",
      },
      typeOptions: {
        0: '固定金额收款单',
        1: '消费者自填金额收款单',
        2: '混合金额收款单',
        3: '导入金额',
      },
      shopList: [],
      cashierPointList: [],
      statusOptions: {
        // 0: '暂停收款',
        1: '收款中',
        2: '已结束',
        3: '已过期',
      },
      billInfo: {
        totalAmount: 0,
        incomeAmount: 0,
        incomeCount: 0,
        refundAmount: 0,
        refundCount: 0,
      },
      table: {
        tableData: [],
        loadingTable: false,
        totalCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      dialog: {
        dialogVisible: false,
        loadingDialog: false,
        loadingConfirmBtn: false,
        form: {},
      },
      showQrDialog: false,
      qrDialogInfo: {
        receiptOrderNo: '',
        receiptName: '',
        merchantName: '',
      },
      showCreateDialog: false,
      currCreateTemplateIndex: 0,
      templateList: [
        {
          name: "自定义模板",
          desc: "手动添加自己需要的问题类型",
          imgUrl: require("../../assets/images/flow/template-icon-0.png"),
        },
        {
          name: "教培模板",
          desc: "默认包含学员姓名、课程名称、金额",
          imgUrl: require("../../assets/images/flow/template-icon-1.png"),
        },
        {
          name: "物业模板",
          desc: "默认包含姓名、楼道号、门牌号、金额",
          imgUrl: require("../../assets/images/flow/template-icon-2.png"),
        },
        {
          name: "校园征订模板",
          desc: "默认包含学生姓名、年级、班级、学号、金额",
          imgUrl: require("../../assets/images/flow/template-icon-3.png"),
        },
      ],
    };
  },
  computed: {
    loginInfo() {
      return JSON.parse(window.localStorage.getItem("LOGIN_INFO"));
    },
    merchantId() {
      return JSON.parse(window.localStorage.getItem("LOGIN_INFO")).merchantId || null;
    },
    billInfoToChinese() {
      const obj = {
        totalAmount: "累计营业收入(元)",
        incomeAmount: "累计收款金额(元)",
        incomeCount: "累计收款笔数(笔)",
        refundAmount: "累计退款金额(元)",
        refundCount: "累计退款笔数(笔)",
      };
      return val => obj[val];
    },
    searchParamsCombine() {
      const [debitNoteStartTime, debitNoteEndTime] = this.rangeTime || [];
      return {
        merchantId: this.merchantId,
        debitNoteStartTime,
        debitNoteEndTime,
        ...this.searchForm,
      };
    },
    shopNameOptions() {
      return this.shopList.map(({ merchantName }) => ({ label: merchantName, value: merchantName }));
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.loginInfo.shopType === 1) this.queryShopMerchantList();
      this.queryTableData();
      this.queryBillInfo();
      this.getCashierPointList();
    },
    async getCashierPointList(shopIds = []) {
      const { data: { data = [] } } = await queryCashierList({ shopIds });
      this.cashierPointList = data.filter(item => item.status === 0);
    },
    handleCreate() {
      const route = this.$store.state.app.visitedViews.find(item => item.path === '/collection-bill/create');
      if (route) {
        this.$alert('您有正在创建的收款单，请继续创建', '提示', {
          confirmButtonText: '确定',
          confirmButtonClass: 'bs-btn',
          callback: (action) => {
            delete route.query.reset;
            this.$router.push(route);
          },
        });
      } else {
        this.showCreateDialog = true;
      }
    },
    handleConfirmCreate() {
      this.showCreateDialog = false;
      this.$router.push({ path: '/collection-bill/create', query: { mode: `${this.currCreateTemplateIndex}`, reset: '1' } });
    },
    sToFixed,
    handleShopNameChange(val) {
      if (val) {
        const item = this.shopList.find(i => i.merchantName === val);
        if (item.shopId) {
          this.searchForm.cashierAreaNo = '';
          this.getCashierPointList([item.shopId]);
        }
      } else {
        this.searchForm.cashierAreaNo = '';
        this.getCashierPointList([]);
      }
    },
    queryShopMerchantList() {
      const { pageNo, finished, pageSize } = this.shopPageInfo;
      if (finished) return false;
      this.shopPageInfo.loading = true;
      getListShopMerchant({ pageNo, pageSize }).then(({ data }) => {
        this.shopPageInfo.loading = false;
        if (String(data.error_code) === "0") {
          this.shopList = [...this.shopList, ...data.data.list];
          if (data.data.totalCount <= pageNo * pageSize) {
            this.shopPageInfo.finished = true;
          } else {
            this.shopPageInfo.pageNo += 1;
          }
        }
      });
      return true;
    },
    async queryBillInfo() {
      const { data: { data } } = await queryListAllRecordSummary(this.searchParamsCombine);
      const billInfoObj = {
        totalAmount: sToFixed(data.totalAmount),
        incomeAmount: sToFixed(data.incomeAmount),
        incomeCount: data.incomeCount,
        refundAmount: sToFixed(data.refundAmount),
        refundCount: data.refundCount,
      };
      Object.assign(this.billInfo, billInfoObj);
    },
    async queryTableData() {
      this.table.loadingTable = true;
      const { pageNo, pageSize } = this.table;
      const params = {
        ...this.searchParamsCombine,
        pageNo,
        pageSize,
      };
      const { data: { data: { list, totalCount } } } = await queryDebitNoteList({ ...params }).finally(() => {
        this.table.loadingTable = false;
      });
      this.table.tableData = list;
      this.table.totalCount = totalCount;
    },
    handleSearch() {
      this.queryTableData();
      this.queryBillInfo();
    },
    exportDetail() {
      const { userName, sessionId } = this.loginInfo;
      const url = `${host}/online/debitNote/exportAllDetail?userName=${userName}&sessionId=${sessionId}`;
      downLoadFileByForm(url, { ...this.searchParamsCombine });
    },
    async handleViewTableDetail({ receiptOrderNo }) {
      this.dialog.dialogVisible = true;
      this.dialog.loadingDialog = true;
      const { data: { data } } = await queryDebitNoteDetail({ receiptOrderNo }).finally(() => {
        this.dialog.loadingDialog = false;
      });
      this.dialog.form = data;
    },
    goToDetail({ receiptOrderNo }) {
      this.$router.push({ name: "collection-bill-detail", query: { receiptOrderNo } });
    },
    showQrCode({ receiptOrderNo, receiptName, merchantName }) {
      this.qrDialogInfo = { receiptOrderNo, receiptName, merchantName };
      this.showQrDialog = true;
    },
    handleCurrentPageChange(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    handleDialogClose() {
      this.dialog.dialogVisible = false;
    },
    handleCloseQrDialog() {
      this.showQrDialog = false;
    },
    handleConfirmDialog() {
      const { receiptOrderNo, merchantId, status } = this.dialog.form;
      this.dialog.loadingConfirmBtn = true;
      closeOrOpenReceipt({ receiptOrderNo, merchantId, switchType: status === 2 ? 0 : 1 }).then(({ data }) => {
        if (data.error_code === 0) {
          this.$message.success('操作成功');
          this.handleDialogClose();
          this.queryTableData();
        }
      }).finally(() => {
        this.dialog.loadingConfirmBtn = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.collection-bill-page {
  background-color: #f7f7f7;

  .tabs {
    display: flex;
    align-items: center;
    height: 80px;
    padding-left: 50px;
    background-color: #fff;
    border-bottom: 1px solid #f2f3f3;

    .tab {
      height: 80px;
      margin-right: 60px;
      font-size: 18px;
      line-height: 80px;
      color: #333;
      cursor: pointer;

      &.active {
        border-bottom: 2px solid #008cff;
      }
    }
  }

  .search {
    padding-top: 40px;
    padding-bottom: 20px;
    padding-left: 50px;
    margin-bottom: 20px;
    background-color: #fff;
  }

  .center-info {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 20px 0;
    margin-bottom: 20px;
    background-color: #fff;
  }

  .table-list {
    overflow: hidden;
    background: #f7f7f7;

    .table-data {
      padding: 40px 50px;
      overflow: hidden;
      background-color: #fff;

      .table-btn {
        margin-right: 10px;
        color: #ff9c00;
        cursor: pointer;
      }

      .t-btn {
        color: #1395ff;
      }
    }
  }

  .template-list {
    .item {
      height: 90px;
      padding: 0 20px;
      margin-bottom: 16px;
      cursor: pointer;
      border: 1px solid #dcdfe6;
      border-radius: 8px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .active {
      background-image: url(../../assets/images/flow/template-active.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border: none;
    }

    .icon {
      width: 54px;
      height: 54px;
      margin-right: 16px;
    }

    .name {
      margin-bottom: 12px;
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }

    .desc {
      font-size: 14px;
      line-height: 1.3;
      color: #999;
    }
  }
}
</style>
